import React from 'react';
import "./Landing.css";
import NavBar from '../Layouts/NavBar';
import LandingSlider from './LandingSlider';
// import LandingPacks from './Components/Landing/LandingPacks';
import MedicalContextProvider from "../Context/MedicalContext";
import { useNavigate } from 'react-router-dom';
import Footer from '../Layouts/Footer';

function Landing() {
    const nav = useNavigate();
    return (

        <>
            <MedicalContextProvider>
                <div className="LandingPage">

                    <div className="NavBarLanding">
                        <NavBar/>
                    </div>
                    
                    <div className='LandingSlider'>
                        <LandingSlider/>
                    </div>
                    <div className="LandingContact">
                        <Footer/>
                    </div>
                </div>
            </MedicalContextProvider>
        </>

    );
}

export default Landing;